export default __webpack_public_path__ + "static/media/sucsess.0120ba60.svg";